import { useEffect, useState } from "react";
import {
  Form,
  Input,
  Label,
  FormGroup,
  FormFeedback,
  Container,
  Card,
  Row,
  Col,
  CardBody,
} from "reactstrap";
import { useParams, useHistory } from "react-router-dom";
import Button from "components/Inputs/TButton";
import Alert from "components/Alert";
import Client from "services/WebAPI";
import moment from "moment";
import { useDispatch } from "react-redux";
import { alertActions } from "redux/_actions";

const Billing = (props) => {
  const [formState, setFormState] = useState({
    commitment: "",
    billingDate: "",
    billingCycle: "",
    stripe: "",
    xero: "",
    amount: "",
  });
  const { id, type } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      let resp = {}
      if(type==="partner"){
        resp = await Client.get(
        `/Billing/FetchPartnerBilling?partnerId=${parseInt(id)}`
      );
      }
      if(type==="customer"){
        resp = await Client.get(
        `/Billing/FetchCustomerBilling?Id=${parseInt(id)}`
      );
      }

      if (resp.data.status) {
        const data = resp.data.result;
        const _data = {
          commitment: data.MinimumCommitment,
          billingDate: moment(data.BillingDate || data.SignUpDate).format(
            "YYYY-MM-DD"
          ),
          billingCycle: data.BillingCycle || "monthly",
          stripe: data.StripeID,
          xero: data.XeroContactID,
          amount: data.Price,
          signupDate: moment(data?.SignUpDate).format("YYYY-MM-DD"),
        };
        setFormState(_data);
      }
    } catch (err) {
      console.log("err", err);
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();
    const req = {
      XeroContactId: formState.xero,
      StripeId: formState.stripe,
      MinimumCommitment: parseInt(formState.commitment),
      BillingDate: moment(formState.billingDate, "YYYY-MM-DD").format(),
      BillingCycle: formState.billingCycle,
      Price: parseFloat(formState.amount),
    };
    try {
      let resp
      if(type==="partner"){
        req.PartnerId=parseInt(id)
        resp = await Client.post("/Billing/UpdatePartnerBilling", req);
      }
      if(type==="customer"){
        req.CustomerId=parseInt(id)
        resp = await Client.post("/Billing/UpdateCustomerBilling", req);
      }
      if (resp.data.status) {
        fetchData();
        dispatch(alertActions.success("Sucessfully Updated"));
      } else dispatch(alertActions.error("Failed to update"));
    } catch (err) {
      console.log("err", err);
      dispatch(alertActions.error("Something went wrong"));
    }
    setTimeout(() => {
      dispatch(alertActions.clear());
    }, 2500);
  };

  const editField = ({ target: { id, value } }) => {
    formState[id] = value;
    setFormState({ ...formState });
  };

  return (
    <div>
      <Container className="container-modal" fluid>
        <div className="common-headers">
          <Button
            className="common-btn-back mr-2"
            outline
            onClick={() => history.go(-1)}
          >
            <i className="fas fa-chevron-left" />
          </Button>
          Manage {type=="partner"? "Partner" : "Customer"} Billing
        </div>
        <Row>
          <Col xs="5">
            <Card className="shadow">
              <CardBody>
                <Form role="form" onSubmit={handleSave}>
                  <FormGroup>
                    <Alert />
                  </FormGroup>
                  <FormGroup>
                    <Label for="commitment">Sign-Up Date</Label>
                    <Input
                      id="commitment"
                      value={formState.signupDate}
                      type="date"
                      disabled
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label for="commitment">
                      Minimum Commitment (Optional)
                    </Label>
                    <Input
                      id="commitment"
                      value={formState.commitment}
                      onChange={editField}
                      type="number"
                    />
                    <FormFeedback>
                      Please enter a minimum commitment
                    </FormFeedback>
                  </FormGroup>
                  <FormGroup>
                    <Label for="amount">Unit Price (Optional)</Label>
                    <Input
                      id="amount"
                      value={formState.amount}
                      onChange={editField}
                      type="number"
                    />
                    <FormFeedback>Please enter a unit price</FormFeedback>
                  </FormGroup>
                  <FormGroup>
                    <Label for="billingDate">Billing Date</Label>
                    <Input
                      id="billingDate"
                      value={formState.billingDate}
                      onChange={editField}
                      type="date"
                    />
                    <FormFeedback>Billing Date</FormFeedback>
                  </FormGroup>
                  <FormGroup>
                    <Label for="billingCycle">Billing Cycle</Label>
                    <Input
                      id="billingCycle"
                      value={formState.billingCycle}
                      onChange={editField}
                      type="select"
                    >
                      <option value={"off"}>None</option>
                      <option value={"monthly"}>Monthly</option>
                      {/* <option value={"yearly"}>Yearly</option> */}
                    </Input>
                    <FormFeedback>Please select a billing cycle</FormFeedback>
                  </FormGroup>
                  <FormGroup>
                    <Label for="stripe">Stripe ID</Label>
                    <Input
                      type="text"
                      id="stripe"
                      value={formState.stripe}
                      onChange={editField}
                    />
                    <FormFeedback>Please enter a stripe ID</FormFeedback>
                  </FormGroup>
                  <FormGroup>
                    <Label for="xero">Xero ID</Label>
                    <Input
                      type="text"
                      id="xero"
                      value={formState.xero}
                      onChange={editField}
                    />
                    <FormFeedback>Please enter a Xero ID</FormFeedback>
                  </FormGroup>

                  <div
                    style={{
                      marginTop: 30,
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Button
                      outline
                      className="common-btn-outlined"
                      color="primary"
                      type="button"
                      onClick={() => history.push(`/billing/history/${type}/${id}`)}
                    >
                      Invoice History
                    </Button>
                    <Button className="common-btn" type="submit">
                      Save
                    </Button>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Billing;
